import React from "react"
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-use';
import tw from 'tailwind.macro'

const Transition = ({children}) =>  {
	const location = useLocation();
		
	const duration = 0.35;
	const variants = {
		initial: {
			opacity: 0,
		},
		animate: {
			opacity: 1,
			transition: {
				duration: duration,
				delay: duration,
				when: 'beforeChildren',
			},
		},
	}
	

	return (
		<AnimatePresence>
			<Wrapper
				className={'transition'}
				key={location.pathname}
				{...variants}
			>
				{children}	
			</Wrapper>
		</AnimatePresence>
	)
}

const Wrapper = styled(motion.div)`
	${tw`w-full h-full`};
`

export default Transition